import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

import { PackageFallback } from './package-fallback'

interface CartThumbProps {
    productId: string
    name: string
    image: string | null
    packageColor: string
    accentColor: string
    className?: string
}

/* Small product picture for cart rows: the photo when there is one, else the pouch */
export const CartThumb: FC<CartThumbProps> = ({ productId, name, image, packageColor, accentColor, className }): ReactNode => {
    return (
        <div className={cn('relative shrink-0 overflow-hidden rounded-2xl border-2 border-brand-choco/10 bg-brand-cream', className)}>
            {image ? (
                <Image src={image} alt={name} fill sizes='96px' className='object-cover' />
            ) : (
                <PackageFallback
                    art={{ id: productId, name, flavor: null, tagline: null, composition: null, sizeLabel: null, packageColor, accentColor, image: null }}
                    showName={false}
                    className='absolute inset-0 scale-125'
                />
            )}
        </div>
    )
}
